import {
	GetPlaceWizardBasicInformationStepResponse,
	GetPlaceWizardRolesAndEmployeesStepResponse,
	PlaceWizardRolesAndEmployeesBar,
	WizardBar,
	WizardRole,
} from "#resources/api/enterprise-generated";
import { LocalWizardEmployee } from "#pages/place/wizard/steps/employees/employees-mocks";
import { createQueryFactory } from "../query-factory";

export const { useApiHook: useGetPlaceWizardStatus } = createQueryFactory(
	"getPlaceWizardStatus",
	{
		retry: false,
		refetchOnWindowFocus: false,
		refetchOnMount: false,
		refetchOnReconnect: false,
	},
);

export const { useApiHook: useGetPlaceWizardBasicInformationStep } = createQueryFactory(
	"getPlaceWizardBasicInformationStep",
	{
		retry: false,
		refetchOnWindowFocus: false,
		refetchOnMount: false,
		refetchOnReconnect: false,
	},
);

export const useGetPlaceWizardConfiguration = (
	params: { placeId: string },
	options?: { enabled?: boolean },
) => {
	return useGetPlaceWizardBasicInformationStep(params, {
		enabled: options?.enabled !== false && Boolean(params.placeId),
	});
};

export const { useApiHook: useGetPlaceWizardBarsAndSectorsStep } = createQueryFactory(
	"getPlaceWizardBarsAndSectorsStep",
	{
		retry: false,
		refetchOnWindowFocus: false,
		refetchOnMount: false,
		refetchOnReconnect: false,
	},
);

export const { useApiHook: useGetPlaceWizardProductsAndMenusStep } = createQueryFactory(
	"getPlaceWizardProductsAndMenusStep",
	{
		retry: false,
		refetchOnWindowFocus: false,
		refetchOnMount: false,
		refetchOnReconnect: false,
	},
);

export const {
	useApiHook: useGetPlaceWizardRolesAndEmployeesStep,
} = createQueryFactory("getPlaceWizardRolesAndEmployeesStep", {
	retry: false,
	refetchOnWindowFocus: false,
	refetchOnMount: false,
	refetchOnReconnect: false,
});

// organizationRoles usa WizardRole (sem quantity) pois quantity é info de frontend,
// inferida no wrapper contando employees por cargo.
export interface WizardEmployeesSummaryData {
	organizationRoles: WizardRole[];
	employees: LocalWizardEmployee[];
	bars: WizardBar[];
}

export type {
	GetPlaceWizardBasicInformationStepResponse,
	GetPlaceWizardRolesAndEmployeesStepResponse,
	PlaceWizardRolesAndEmployeesBar,
	WizardRole,
};
